module.exports = __webpack_public_path__ + "static/img/90.b685278.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/90.png
// module id = g6i0
// module chunks = 1